import styles from '../shared/styles';
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { HigherPlanTag } from '../../../../styles/styled';

const ToggleWithInput = props => {
  const {
    mainFlag,
    onChangeToggleFn,
    inputValue,
    onChangeValueFn,
    mainText,
    subText,
    inputLabel,
    inputUnits,
    disabled,
    disabledByPlan,
    onFeatureNotAllowed,
  } = props;

  return (
    <div style={styles.toggleOptionsContent}>
      <Toggle
        disabled={disabled || disabledByPlan}
        className="toggle-green"
        checked={mainFlag}
        onChange={onChangeToggleFn}
      />
      <div style={styles.optionToggleWrapper}>
        <div style={styles.optionToggleMainText}>{mainText}</div>
        <div style={styles.optionToggleSubText}>
          {subText}
          {disabledByPlan && (
            <HigherPlanTag className="margin-one-left btn" onClick={() => onFeatureNotAllowed()} />
          )}
        </div>
        {mainFlag && (
          <div>
            <span style={styles.toggleWithValueInputLabel}>{inputLabel}</span>
            <input
              style={styles.audioProcessingOverlapOption}
              type="text"
              value={inputValue}
              onChange={onChangeValueFn}
            />
            <span style={styles.toggleWithValueInputUnits}>{inputUnits}</span>
          </div>
        )}
      </div>
    </div>
  );
};

ToggleWithInput.propTypes = {
  mainFlag: PropTypes.bool,
  onChangeToggleFn: PropTypes.func,
  inputValue: PropTypes.number,
  onChangeValueFn: PropTypes.func,
  mainText: PropTypes.string,
  subText: PropTypes.string,
  inputLabel: PropTypes.string,
  inputUnits: PropTypes.string,
  disabled: PropTypes.bool,
  disabledByPlan: PropTypes.bool,
  onFeatureNotAllowed: PropTypes.func,
};

ToggleWithInput.defaultProps = {
  mainFlag: false,
  onChangeToggleFn: () => {},
  inputValue: 5,
  onChangeValueFn: () => {},
  mainText: 'Apply to existing tracks',
  subText:
    '(This option adds updated intro/outro to all published tracks and replaces any existing intro/outro)',
  inputLabel: 'Overlap with main audio: ',
  inputUnits: 'second(s)',
  disabled: false,
  disabledByPlan: false,
  onFeatureNotAllowed: () => {},
};

export default ToggleWithInput;
